export default "__VITE_ASSET__508d956f__"